import Big from "big.js";
import moment from "moment";

type OilRequest = {
  regDatetime?: string;
  transportDate?: string;
  oils: {
    markup?: number;
    amount: number;
  }[];
};

export const isMarkup = (oilRequest: OilRequest) => {
  return oilRequest.oils.some((o) => o.markup);
};

export const calculateMarkupTotal = (oilRequest: OilRequest): string => {
  let markup = new Big(0);
  oilRequest.oils.forEach((o) => {
    if (o.markup) {
      markup = markup.plus(new Big(o.markup || 0).mul(o.amount));
    }
  });

  return markup.toFixed();
};

export const vat2025Date = moment("2025-6-31");

export const getVatRate = (oilRequest: OilRequest): string => {
  if (moment(oilRequest.transportDate).isAfter(vat2025Date)) {
    return "24";
  }

  return "22";
};
